// extracted by mini-css-extract-plugin
export default {"UpdateProviderConfigContent":"UpdateProviderConfigContet_UpdateProviderConfigContent__LyRTn"};